module.exports = __webpack_public_path__ + "img/sankaku_54_blue.a2a7e951.png";